import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

export default class SlimSelectController extends Controller {
  static targets = ["input"];

  connect() {
    const elementOptions = JSON.parse(
      this.inputTarget.dataset?.slimOptions || "{}",
    );
    const isInsideDialog = Boolean(this.inputTarget.closest("dialog"));

    this.slimSelect = new SlimSelect({
      select: this.inputTarget,
      settings: {
        placeholderText: "Escolha...",
        searchText: "Nenhum resultado...",
        searchPlaceholder: "Pesquise...",
        allowDeselect: true,
        contentLocation: isInsideDialog
          ? this.inputTarget.parentElement
          : document.body,
        contentPosition: "fixed",
      },
      ...elementOptions,
    });
  }

  disconnect() {
    if (this.slimSelect) {
      this.slimSelect.destroy();
      this.slimSelect = null;
    }
  }
}
